import React from 'react';
import { Text, Button, tokens } from '@fluentui/react-components';
import { LicenseCheck } from '../../types/license';

interface LicenseBannerProps {
  license: LicenseCheck | null;
  taskCount: number;
  isReadOnly: boolean;
  onUpgradeClick: () => void;
}

export const ReadOnlyBanner: React.FC<{ isReadOnly: boolean }> = ({ isReadOnly }) => {
  if (!isReadOnly) return null;

  return (
    <div style={{
      backgroundColor: tokens.colorNeutralBackground3,
      padding: '0.5rem 2rem',
      borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
      textAlign: 'center',
    }}>
      <Text weight="semibold" style={{ color: tokens.colorNeutralForeground2 }}>
        Read-only view - You cannot make changes to this board
      </Text>
    </div>
  );
};

export const LicenseLimitBanner: React.FC<LicenseBannerProps> = ({
  license,
  taskCount,
  isReadOnly,
  onUpgradeClick,
}) => {
  if (isReadOnly) return null;
  if (!license) return null;
  if (license.plan !== 'free' && !license.isExpired) return null;
  if (!license.restrictions.maxTasksPerBoard) return null;

  const maxTasks = license.restrictions.maxTasksPerBoard;

  // Don't show banner when there are fewer tasks than the limit
  if (taskCount < maxTasks) return null;

  return (
    <div
      onClick={onUpgradeClick}
      style={{
        backgroundColor: tokens.colorPaletteRedBackground2,
        padding: '0.5rem 2rem',
        borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        cursor: 'pointer',
      }}
    >
      <Text weight="semibold" style={{ color: tokens.colorNeutralForeground1 }}>
        {license.isExpired
          ? `License expired. Task limit: ${taskCount}/${maxTasks}.`
          : `Task limit reached (${taskCount}/${maxTasks}).`
        }
      </Text>
      <Button
        appearance="primary"
        size="small"
        onClick={(e) => { e.stopPropagation(); onUpgradeClick(); }}
      >
        {license.isExpired ? 'Renew Now' : 'Get License'}
      </Button>
    </div>
  );
};
